<template>
  <owal-modal
    :show="show"
  >
    <div
      slot="content"
      class="owal logo spinner container"
    >
      <owal-spinner-logo
        class="owal logo spinner content"
      />
    </div>
  </owal-modal>
</template>

<script>
import OwalSpinnerLogo from '@/libraries/owal-ui/spinners/OwalSpinnerLogo'
import OwalModal from './OwalModal'

export default {
  name: 'OwalLoadingModalSpinner',
  components: { OwalSpinnerLogo, OwalModal },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.owal.logo.spinner.container {
  border-radius: 5px;
  height: 200px;
  width: 200px;
  -webkit-clip-path: inset(0 0 0 0 round 5px);
  clip-path: inset(0 0 0 0 round 5px);
  background-color: #ffffff;
}

.owal.logo.spinner.content {
  height: 100%;
  width: 100%;
}

.owal.logo.spinner.content img {
  animation: spinner-spin infinite 1.0s ease-in-out;
}
</style>
